import Vue from 'vue';
import CookieControl from "\u002Fapp\u002Fnode_modules\u002Fnuxt-cookie-control\u002Fcomponents\u002FCookieControl.vue";
import CookieIframe from "\u002Fapp\u002Fnode_modules\u002Fnuxt-cookie-control\u002Fcomponents\u002FCookieIframe.vue";
export default(context, inject) =>{
  let cookies = {
    modal: false,
    consent: false,
    enabled: [],
    enabledList: [],
    optional: []
  }

  Object.assign(cookies, {"barPosition":"bottom-full","controlButton":true,"cssPolyfill":true,"css":true,"colors":{"barTextColor":"#4d4d4d","barBackground":"#efefef","barButtonColor":"#000","barButtonBackground":"#fff","barButtonHoverColor":"#fff","barButtonHoverBackground":"#000","modalButtonColor":"#000","modalButtonBackground":"#fff","modalButtonHoverColor":"#fff","modalButtonHoverBackground":"#000","controlButtonBackground":"#12957b","controlButtonHoverBackground":"#2e495e","controlButtonIconHoverColor":"#fff","controlButtonIconColor":"#fff","checkboxActiveBackground":"#2e495e","checkboxInactiveBackground":"#ede1e1","checkboxActiveCircleBackground":"#00c58e","checkboxInactiveCircleBackground":"#f44336","checkboxDisabledBackground":"#ddd","checkboxDisabledCircleBackground":"#fff"},"text":{"locale":{"de":{"barTitle":"Cookie Einstellungen","barDescription":"Wir verwenden Cookies, um Ihnen ein optimales Webseiten-Erlebnis zu bieten. Dazu zählen Cookies, die für den Betrieb der Seite und für die Steuerung unserer kommerziellen Unternehmensziele notwendig sind, sowie solche, die lediglich zu anonymen Statistikzwecken, für Komforteinstellungen oder zur Anzeige personaliesierter Inhalte genutzt werden.","acceptAll":"Alle bestätigen","declineAll":"Alle ablehnen","manageCookies":"Cookies verwalten","unsaved":"Sie haben ungespeicherte Einstellungen","close":"Schließen","save":"Speichern","necessary":"Erforderliche Cookies","optional":"Optionale Cookies","functional":"Funktionale Cookies","blockedIframe":"Um dies zu sehen, aktivieren Sie bitte funktionale Cookies","here":"hier"},"en":{"barTitle":"Cookie Configuration","barDescription":"We use cookies to provide you with the best website experience. These include cookies that are necessary for the operation of the site and to manage our commercial business objectives, as well as those that are only used for anonymous statistical purposes, for convenience settings or to display personalised content.","acceptAll":"Confirm all","declineAll":"Decline all","manageCookies":"Manage cookies","unsaved":"You have unsaved settings","close":"Close","save":"Save","necessary":"Required cookies","optional":"Optional cookies","functional":"Functional cookies","blockedIframe":"To see this, please enable functional cookies","here":"here"}}},"necessary":[{"name":{"de":"Notwendige Cookies","en":"Necessary cookies"},"description":{"de":"Diese Technologien sind erforderlich, um die Kernfunktionalität der Webseite zu aktivieren (Cookie Control Consent).","en":"These technologies are required to enable the core functionality of the website (Cookie Control Consent)."}}],"optional":[{"name":{"de":"Marketing","en":"Marketing"},"identifier":"marketing","description":{"de":"Marketing-Cookies werden verwendet, um Besucher auf Webseiten zu verfolgen. Ziel ist es, Anzeigen zu schalten, die für den einzelnen Nutzer relevant und ansprechend sind und damit für Publisher und Drittwerber wertvoller sind (LinkedIn Ads).","en":"Marketing cookies are used to track visitors to websites. The aim is to serve ads that are relevant and engaging to the individual user and therefore more valuable to publishers and third party advertisers (LinkedIn Ads)."},"async":true,"initialState":false,"src":"https:\u002F\u002Fsnap.licdn.com\u002Fli.lms-analytics\u002Finsight.min.js","accepted":() => {
        window._linkedin_data_partner_ids =
        window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(process.env.LINKEDIN_PID);
      },"declined":() => {
        window.$nuxt.$cookies.remove("marketing");
        window.$nuxt.$cookies.remove("ln_or");
      }},{"name":{"de":"Statistiken","en":"Statistics"},"identifier":"statistics","description":{"de":"Statistik Cookies erfassen Informationen anonym. Diese Informationen helfen uns zu verstehen, wie unsere Besucher unsere Website nutzen (Google Ads). Daten werden erst nach einer bestimmten Interaktion erhoben, beispielsweise wenn Sie den Newsletter abonnieren.","en":"Statistics cookies collect anonymized information. This information helps us to understand how our visitors use our website (Google Ads). Data is only collected after a certain interaction, for instance when subscribing to the newsletter."},"async":true,"initialState":false,"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=AW-879485195","accepted":() => {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          dataLayer.push(arguments);
        }
        gtag("js", new Date());
        gtag("config", `${process.env.GOOGLE_AD}`);
      },"declined":() => {
        window.$nuxt.$cookies.remove("statistics");
        window.$nuxt.$cookies.remove("gad"); // Remove any existing Google Ad Manager cookies
        window.$nuxt.$cookies.remove("_gcl_au"); // Remove any existing Google Ad Manager cookies
        window.$nuxt.$cookies.remove("1P_JAR"); // Remove any existing Google Ad Manager cookies
        window.$nuxt.$cookies.remove("test_cookie"); // Remove any existing Google Ad Manager cookies
        window.$nuxt.$cookies.remove("DSID"); // Remove any existing Google Ad Manager cookies
        window.$nuxt.$cookies.remove("DV"); // Remove any existing Google Ad Manager cookies
        window.$nuxt.$cookies.remove("IDE"); // Remove any existing Google Ad Manager cookies
        window.$nuxt.$cookies.remove("CONSENT"); // Remove any existing Google Ad Manager cookies
        window.$nuxt.$cookies.remove("SOCS"); // Remove any existing Google Ad Manager cookies
        window.$nuxt.$cookies.remove("OTZ"); // Remove any existing Google Ad Manager cookies
        window.$nuxt.$cookies.remove("NID"); // Remove any existing Google Ad Manager cookies
        window.$nuxt.$cookies.remove("AEC"); // Remove any existing Google Ad Manager cookies
        window.$nuxt.$cookies.remove("OGPC"); // Remove any existing Google Ad Manager cookies
        window.$nuxt.$cookies.remove("UULE"); // Remove any existing Google Ad Manager cookies
        window.$nuxt.$cookies.remove("__Secure-ENID"); // Remove any existing Google Ad Manager cookies
      }}],"iframe":"\u002Fapp\u002Fnode_modules\u002Fnuxt-cookie-control\u002Fcomponents\u002FCookieIframe.vue","component":"\u002Fapp\u002Fnode_modules\u002Fnuxt-cookie-control\u002Fcomponents\u002FCookieControl.vue","globalName":"nuxt"});
  if({"barTextColor":"#4d4d4d","barBackground":"#efefef","barButtonColor":"#000","barButtonBackground":"#fff","barButtonHoverColor":"#fff","barButtonHoverBackground":"#000","modalButtonColor":"#000","modalButtonBackground":"#fff","modalButtonHoverColor":"#fff","modalButtonHoverBackground":"#000","controlButtonBackground":"#12957b","controlButtonHoverBackground":"#2e495e","controlButtonIconHoverColor":"#fff","controlButtonIconColor":"#fff","checkboxActiveBackground":"#2e495e","checkboxInactiveBackground":"#ede1e1","checkboxActiveCircleBackground":"#00c58e","checkboxInactiveCircleBackground":"#f44336","checkboxDisabledBackground":"#ddd","checkboxDisabledCircleBackground":"#fff"} !== false){
    cookies.colors = {
      barTextColor: '#fff',
      modalOverlay: '#000',
      barBackground: '#000',
      barButtonColor: '#000',
      modalTextColor: '#000',
      modalBackground: '#fff',
      modalOverlayOpacity: 0.8,
      modalButtonColor: '#fff',
      modalUnsavedColor: '#fff',
      barButtonHoverColor: '#fff',
      barButtonBackground: '#fff',
      modalButtonHoverColor: '#fff',
      controlButtonIconColor: '#000',
      modalButtonBackground: '#000',
      controlButtonBackground: '#fff',
      barButtonHoverBackground: '#333',
      checkboxActiveBackground: '#000',
      controlButtonIconHoverColor: '#fff',
      checkboxInactiveBackground: '#000',
      modalButtonHoverBackground: '#333',
      checkboxDisabledBackground: '#ddd',
      controlButtonHoverBackground: '#000',
      checkboxActiveCircleBackground: '#fff',
      checkboxInactiveCircleBackground: '#fff',
      checkboxDisabledCircleBackground: '#fff',
    };
    Object.assign(cookies.colors, {"barTextColor":"#4d4d4d","barBackground":"#efefef","barButtonColor":"#000","barButtonBackground":"#fff","barButtonHoverColor":"#fff","barButtonHoverBackground":"#000","modalButtonColor":"#000","modalButtonBackground":"#fff","modalButtonHoverColor":"#fff","modalButtonHoverBackground":"#000","controlButtonBackground":"#12957b","controlButtonHoverBackground":"#2e495e","controlButtonIconHoverColor":"#fff","controlButtonIconColor":"#fff","checkboxActiveBackground":"#2e495e","checkboxInactiveBackground":"#ede1e1","checkboxActiveCircleBackground":"#00c58e","checkboxInactiveCircleBackground":"#f44336","checkboxDisabledBackground":"#ddd","checkboxDisabledCircleBackground":"#fff"});
  }

  let methods = {
    get: (cookie) => {
      if(process.browser){
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        let name = `${cookie}=`;
        for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
      }
      return '';
    },

    set: ({name, value='', expires='', path='/', domain}) => {
      let domainName = domain ? domain : cookies.domain ? `.${cookies.domain}` : domain;
      if(process.browser){
        document.cookie = `${name}=${value};expires=${expires};path=${path}${domainName !== undefined ? `;domain=${domainName}` : ';'}`;
      } else if(process.server){
        context.res.setHeader('Set-Cookie', [`${name}=${value}; Expires=${expires}; Path=${path}${domainName !== undefined ? `; Domain=${domainName}` : ';'}`]);
      }
    },

    isEnabled: (identifier) => {
      return cookies.enabledList.includes(identifier) || cookies.enabledList.includes(cookies.slugify(identifier))
    },

    setBlockedIframes: (content) =>{
      let type = (typeof(content)).toLowerCase();
      let c = type !== 'string' ? JSON.stringify(content) : content;
      c = c.replace(/&lt;/g, '<');
      c = c.replace(/&gt;/g, '>');
      if(context.app.$cookies.enabled.filter(c =>{return c.name === 'functional'}).length === 0){
        c = c.replace(/<iframe/g, `<div class='cookieControl__BlockedIframe '`);
        c = c.replace(/<\/iframe/g, `<p>${context.app.$cookies.text.blockedIframe !== undefined ? context.app.$cookies.text.blockedIframe : ''} <a href='#' onclick='event.preventDefault(); $${cookies.globalName}.$cookies.modal = true'>${context.app.$cookies.text.here !== undefined ? context.app.$cookies.text.here: ''}</a></p></div`);
      }
      return type !== 'string' ? JSON.parse(c) : c
    },

    slugify: (str) =>{
      str = str.replace(/^\s+|\s+$/g, '');
      str = str.toLowerCase();
      let from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
      let to   = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
      for (let i = 0, l = from.length; i < l ; i++){
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
      }

      str = str.replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');

      return str;
    },

    remove: (name) =>{
      if(process.browser){
        let domain = window.location.hostname;
        cookies.set({name, expires: 'Thu, 01 Jan 1970 00:00:00 GMT', domain });
        for (let j = domain.split('.'); j.length;) {
          let o = j.join('.');
          cookies.set({name, expires: 'Thu, 01 Jan 1970 00:00:00 GMT', domain: `.${o}` });
          j.shift();
        }
      }
    },

    setConsent: (isInit=false) =>{
      cookies.consent = cookies.get('cookie_control_consent') === 'true' ? true : false;
      cookies.enabled = [];
      cookies.enabledList = [];
      if(cookies.consent === true){
        let enabledFromCookie = cookies.get('cookie_control_enabled_cookies');
        cookies.enabled.push(...cookies.optional.filter(c => {
          let cookieName = typeof(c.name) === 'string' ? c.name : c.name[Object.keys(c.name)[0]]
          return enabledFromCookie.includes(c.identifier || cookies.slugify(cookieName))
        }));
        cookies.enabledList = cookies.enabled.length > 0 ? cookies.enabled.map(c => {
          let cookieName = typeof(c.name) === 'string' ? c.name : c.name[Object.keys(c.name)[0]]
          return c.identifier || cookies.slugify(cookieName)
        }) : [];
      }

      if(cookies.necessary) cookies.enabled.push(...cookies.necessary.filter(c => {return c.src || c.accepted}))

      if(process.client && !isInit){
        setHead();
        clearCookies();
        callAcceptedFunctions();
      }
    }
  }

  Object.assign(cookies, methods);

  const clearCookies = () =>{
    let disabled = cookies.optional.filter(c => {
      let cookieName = typeof(c.name) === 'string' ? c.name : c.name[Object.keys(c.name)[0]]
      return !cookies.enabledList.includes(c.identifier || cookies.slugify(cookieName))
    });
    if(disabled.length > 0){
      disabled.forEach(c => {
        if(c.declined) c.declined();
        if(c.cookies && c.cookies.length > 0){
          c.cookies.forEach(i => {
            cookies.remove(i);
          })
        }
        // if(c.src){
        //   for(let s of [...document.head.querySelectorAll(`script[src="${c.src}"]`)]){
        //     s.parentNode.removeChild(s)
        //   }
        // }
      })
    }
  }

  const setHead = () =>{
    if(cookies.enabled.length > 0){
      let head = document.getElementsByTagName('head')[0];
      cookies.enabled.forEach(c =>{
        if(c.src){
          let script = document.createElement('script');
          script.src = c.src;
          head.appendChild(script);
          script.addEventListener('load', () =>{
            if(c.accepted) c.accepted();
          })
        }
      })
    }
  }

  const callAcceptedFunctions = () =>{
    if(cookies.enabled.length > 0){
      cookies.enabled.forEach(c =>{
        if(c.accepted) c.accepted();
      })
    }
  }

  const capitalize = (s) =>{
    if(typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }

  cookies.setConsent(true)

  if(process.client){
    let globalName = capitalize(cookies.globalName) || 'Nuxt';
    window[`on${globalName}Ready`](() => {
      cookies.setConsent()
    })
  }

  inject('cookies', cookies);
  if(cookies.blockIframe) Vue.component('CookieIframe', CookieIframe);
  Vue.component('CookieControl', CookieControl);
}